var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"tip",on:{"click":_vm.exportWord}},[_vm._v("Выгрузить ответы в Word")])])}
var staticRenderFns = []

export { render, staticRenderFns }